import { useEffect } from 'react';
import { useCommandMenuContext } from 'src/contexts/CommandMenuContext/CommandMenuContext';
import {
  SiteThemeOption,
  useSiteTheme,
} from 'src/contexts/SiteTheme/SiteThemeContext';
import { CommandOptionType } from 'src/WebApiController';

import { useEventCallback } from './useEventCallback';

export const useToggleTheme = () => {
  const { registerCommand, unregisterCommand } = useCommandMenuContext();

  const { isDarkMode, setSiteMode } = useSiteTheme();

  const toggleTheme = useEventCallback(() => {
    if (isDarkMode) {
      setSiteMode(SiteThemeOption.Light);
    } else {
      setSiteMode(SiteThemeOption.Dark);
    }
  });

  useEffect(() => {
    registerCommand({
      command: {
        id: CommandOptionType.ToggleTheme,
        onSelect: toggleTheme,
      },
    });

    return () => {
      unregisterCommand({ commandId: CommandOptionType.ToggleTheme });
    };
  }, [toggleTheme, registerCommand, unregisterCommand]);
};
